module.exports = __webpack_public_path__ + "static/img/image045.916da69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image045.png
// module id = OnyL
// module chunks = 1